export default class ArticleCode {
  constructor(element) {
    this.$el = $(element)
    this.$copyBtn = this.$el.find('.article-code__copy-btn')
    this.$copyContent = this.$el.find('code')
    this.init();
  }
  init() {
    const {$copyBtn, $copyContent} = this
    const $this = this
    $copyBtn.on('click', function (e) {
      const text = $copyContent.text();
      $this.copyTextToClipboard(text);
    })
  }
  copyTextToClipboard(text) {
    navigator.clipboard.writeText(text)
      .then(() => {
        console.log('Text copied to clipboard');
      })
      .catch(err => {
        console.error('Error in copying text: ', err);
      });
  }
}
